import * as sharedApi from '../api';
import { fetchSchemasForTaxYearTypes, fetchSchemasCompareReportTypes } from './types';
import { apiAction } from '../../shared/store/apiAction';

export const fetchSchemasForTaxYear = apiAction({
  types: fetchSchemasForTaxYearTypes,
  apiAction: sharedApi.fetchSchemasForTaxYear,
});
export const fetchSchemasCompareReport = apiAction({
  types: fetchSchemasCompareReportTypes,
  apiAction: sharedApi.fetchSchemasCompareReport,
});
